// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"beq_a bhn_tr","StrollerBoxWidget__imageCounselling":"beq_b bhn_kg"};